module.exports = __webpack_public_path__ + "assets/success-smiley.svg";